import React, { useState } from 'react';
import { Search, Tune, Close } from '@mui/icons-material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  Box,
  IconButton,
  InputBase,
  Paper,
  Menu,
  MenuItem,
  Typography,
  Divider
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const priceRanges = [
  { label: '1K - 10K', min: 1000, max: 10000 },
  { label: '10K - 50K', min: 10000, max: 500000 },
  { label: '50K - 1L', min: 50000, max: 100000 },
  { label: '1L - 20L', min: 100000, max: 2000000 },
  { label: '20L - 40L', min: 2000000, max: 4000000 },
  { label: '40L - 60L', min: 4000000, max: 6000000 },
  { label: '60L & above', min: 6000000, max: Infinity }
];

const CustomSearchBar = ({ value, onChange, onPriceFilterChange }) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current route
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);

  const handleTuneClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handlePriceRangeSelect = (range) => {
    setSelectedPriceRange(range);
    onPriceFilterChange?.(range);
    handleMenuClose();
  };

  const clearPriceFilter = () => {
    setSelectedPriceRange(null);
    onPriceFilterChange?.(null);
    handleMenuClose();
  };

  const handleClearInput = () => {
    onChange({ target: { value: '' } });
  };

  const handleSubmit = (e) => e.preventDefault();

  // Hide filter button and menu on /user-buy route
const hideFilterRoutes = ["/user-buy", "/user-bestdeals", "/user-rent", "/user-lease"];
const hideFilter = hideFilterRoutes.includes(location.pathname);

  return (
    <Box sx={{ position: 'relative' }}>
      <Paper
        component="form"
        elevation={0}
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '30px',
          px: 1,
          backgroundColor: '#f2f5f7',
          border: '1px solid black',
          mx: 0.5,
          my: 0.5
        }}
      >
        {/* Back Button */}
        <IconButton onClick={() => navigate(-1)} sx={{ color: 'black' }}>
          <ArrowBackIosNewIcon />
        </IconButton>

        {/* Search Input */}
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Search"
          value={value}
          onChange={onChange}
        />

        {/* Clear Input */}
        {value && (
          <IconButton onClick={handleClearInput} sx={{ color: 'black' }}>
            <Close fontSize="small" />
          </IconButton>
        )}

        {/* Search Icon */}
        <IconButton type="submit" sx={{ color: 'black' }}>
          <Search />
        </IconButton>

        {/* Filter Icon - hidden on /user-buy */}
        {!hideFilter && (
          <IconButton
            sx={{ color: 'black' }}
            onClick={handleTuneClick}
            aria-label="filter"
            aria-controls="filter-menu"
            aria-haspopup="true"
          >
            <Tune />
          </IconButton>
        )}
      </Paper>

      {/* Filter Menu - hidden on /user-buy */}
      {!hideFilter && (
        <Menu
          id="filter-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            style: {
              width: '250px',
              padding: '8px 0'
            }
          }}
        >
          <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
            Price Range
          </Typography>
          <Divider />
          {priceRanges.map((range) => (
            <MenuItem
              key={range.label}
              onClick={() => handlePriceRangeSelect(range)}
              selected={selectedPriceRange?.label === range.label}
            >
              {range.label}
            </MenuItem>
          ))}

          {selectedPriceRange && (
            <>
              <Divider />
              <MenuItem onClick={clearPriceFilter} sx={{ color: 'error.main' }}>
                Clear Filter
              </MenuItem>
            </>
          )}
        </Menu>
      )}
    </Box>
  );
};

export default CustomSearchBar;
